
/**
 * Returns true if each value in structure `a` is equal to its
 * equivalent in structure `b`, and false otherwise.
 *
 * @param  {IterableCollection} a
 * @param  {IterableCollection} b
 * @param  {object} options
 * @param  {boolean} options.strictTypeCheck=false
 *         For iterable objects, should a and b be of the same
 *         type, or just both be one of the supported iterable
 *         objects? (non-iterables are always type checked)
 * @param {boolean} options.allowSubTypes=true
 *        Should instanceof check suffice
 *        for type equality?
 * @return {boolean}
 */
//eslint-disable-next-line max-statements
export default function deepEquals (a, b, {strictTypeCheck = false, allowSubTypes = true}) {
  if (this.isIterable(a)) {
    if (strictTypeCheck) {
      if (allowSubTypes) {
        if (!(a instanceof b.constructor || b instanceof a.constructor)) {
          return false;
        }
      } else {
        if (a.constructor !== b.constructor) {
          return false;
        }
      }
    } else {
      if (!this.isIterable(b)) {
        return false;
      }
    }
    if (this.count(a) !== this.count(b)) {
      return false;
    }
    for ( let getValue of this.valueGetters(a)) {
      if (!this.hasKey(b, getValue.key)) {
        return false;
      }
      if (!this.deepEquals(getValue(a), getValue(b), strictTypeCheck, allowSubTypes)) {
        return false;
      }
    }
    for (let key of this.keys(b)) {
      if (!this.hasKey(a, key)) {
        return false;
      }
    }
    return true;
  } else {
    return this.valueEquals(a, b, allowSubTypes);
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/core/deepEquals.js